"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecifierName = void 0;
var SpecifierName;
(function (SpecifierName) {
    SpecifierName["total"] = "total";
    SpecifierName["hcp"] = "hcp";
    SpecifierName["periodnr"] = "periodnr";
    SpecifierName["overtimenr"] = "overtimenr";
    SpecifierName["halfnr"] = "halfnr";
    SpecifierName["inningnr"] = "inningnr";
    SpecifierName["quarternr"] = "quarternr";
    SpecifierName["setnr"] = "setnr";
    SpecifierName["gamenr"] = "gamenr";
    SpecifierName["mapnr"] = "mapnr";
    SpecifierName["xth"] = "xth";
    SpecifierName["roundnr"] = "roundnr";
    SpecifierName["pointnr"] = "pointnr";
    SpecifierName["score"] = "score";
    SpecifierName["top"] = "top";
    SpecifierName["goalnr"] = "goalnr";
    SpecifierName["from"] = "from";
    SpecifierName["to"] = "to";
    SpecifierName["minute"] = "minute";
    SpecifierName["competitornumber"] = "competitornumber";
    SpecifierName["winners"] = "winners";
    SpecifierName["killnr"] = "killnr";
})(SpecifierName = exports.SpecifierName || (exports.SpecifierName = {}));
//# sourceMappingURL=constants.js.map